import { createReducer } from 'redux-act';

import * as settingsActions from './actions';

const initialState = {};

const reducer = createReducer({}, initialState);

reducer.on(settingsActions.saveConfiguration, (state, config) => ({ ...state, config }));
reducer.on(settingsActions.saveQuery, (state, query) => ({ ...state, query }));

export default reducer;
